module.exports = __webpack_public_path__ + "img/google-play.4f0ef07e.png";